import React from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
//import NumberFormatCustom  from './NumberFormatCustom';
import moment from 'moment';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Portal from '@mui/material/Portal';


/*import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';*/
import ManagedDropdown from "./ManagedDropdown"




import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AppBar from '@mui/material/AppBar';


import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';

import DownloadIcon from '@mui/icons-material/GetApp';
import UploadIcon from '@mui/icons-material/Publish';

import SecureImage from './SecureImage';

import { RemoveCircle } from '@mui/icons-material';

import ObjectPicker from './ObjectPicker';
import Checkbox from './Checkbox';
import CheckboxList from './CheckboxList';
import HtmlEditor from './HtmlEditor2';
import CodeEditor from './CodeEditor';
import BienThe from './BienThe';
import TextField from './TextField';
import Picker from './Picker';
import AutoCompleteInput from './AutoCompleteInput';
import AuthContext from "./auth/Context";
import FormBase from "./FormBase"
import Files from "./Files"
import { numeral } from "../utils";
import * as utils from "../utils"
import NumberField  from './NumberField';
export const getRefCondition = utils.getRefCondition;
export const getItemsForPicker = utils.getItemsForPicker;
export const getItemsForCompoleteInput = utils.getItemsForCompoleteInput;

class GroupTabs extends React.Component{
    constructor(props){
        super(props);
        this.state={
            data:cloneDeep(this.props.data),
            currentTab:0,
            load:0
        }
        this.isHidden = this.isHidden.bind(this);
        this.prepareFields = this.prepareFields.bind(this);
        this.download = this.download.bind(this);
        this.renderFields = this.renderFields.bind(this);
    }
    async componentDidMount(){
        const {default:InputBase} = await import(
            /* webpackPrefetch: true */
            /* webpackChunkName: "InputBase" */
            "./InputBase"
          );
        this.setState({
            InputBase,load:this.state.load+1
        },()=>{
            this.prepareFields(this.props.data);
            this.setState({load:this.state.load+1});
        })
    }
    shouldComponentUpdate(nextProps,nextState){
        if(nextState.load!==this.state.load || nextState.currentTab!==this.state.currentTab){
            return true;
        }
        if(!isEqual(nextProps.data,this.state.data)){
            //console.log("data changed, grouptabs will rerender:",this.props.group || this.props.name)
            this.prepareFields(nextProps.data);
            // eslint-disable-next-line react/no-direct-mutation-state
            this.state.data = cloneDeep(nextProps.data);
            return true;
        }
        if(!isEqual(nextProps.fields,this.props.fields)){
            //console.log("fields group changed, grouptabs rerender:",this.props.group || this.props.name)
            this.prepareFields(this.state.data,nextProps.fields);
            return true;
        }
        return false;
    }
    async download(url,filename){
        if(!filename) filename = url.split("/").pop();
        if(url.indexOf("/file/download/")>0){
            try{
                let f = await this.context.apis.asyncGetData(this.context.getToken(),"file",{_id:filename},null,false,false,{id_app:this.props.idApp});
                if(f) filename = f.file.name;
            }catch(e){
                console.error(e);
            }
        }
        this.context.apis.downloadFile(url + "?access_token=" + this.context.getToken(),filename)
    }
    async handleValueChanged(field,value,ref_value){
        if(this.props.readOnly) return;
        if(field.type==="String" && value[field.name]){
            if(field.maxlength && value[field.name].length>field.maxlength) return;
            if(field.uppercase) value[field.name] = value[field.name].toUpperCase();
            if(field.lowercase) value[field.name] = value[field.name].toLowerCase();
        }
        if(field.max && field.type==="Number" && value[field.name] && value[field.name]>field.max) value[field.name] = field.max;
        if(field.min && field.type==="Number" && value[field.name] && value[field.name]<field.min) value[field.name] = field.min;

        const _data = cloneDeep(this.state.data);
        const old_data = cloneDeep(this.state.data);
        
        const _value = cloneDeep(value);
        for(let k in _value){
            _data[k] = _value[k];
        }
        if(field.handle_value_changed){
            this.context.setProgressStatus(true);
            try{
                if(typeof(field.handle_value_changed)=="function"){
                    await field.handle_value_changed(this.props.master|| _data,_data,_data,old_data,_value,ref_value||{},utils,this.context.apis,this.context,moment,numeral);
                }else{
                    let bodyFunction = `return (async ()=>{
                        ${field.handle_value_changed}
                    })()`;
                    //let _utils = {sum:Math.sum,roundBy:Math.roundBy};
                    const func= new Function("master","detail","data","old_data", "value","ref_value","utils","API","context","moment","numeral", bodyFunction);
                    await func(this.props.master|| _data,_data,_data,old_data,_value,ref_value||{},utils,this.context.apis,this.context,moment,numeral);
                }
                
            }catch(e){
                for(key in old_data){
                    _data[key] = old_data[key];
                }
                console.error("error handle value changed at field",field.name,e.message||e,field.handle_value_changed);
            }
            this.context.setProgressStatus(false);
        }
        this.prepareFields(_data);

        this.setState({data:_data,load:this.state.load+1},()=>{
            if(this.props.handleValueChanged) this.props.handleValueChanged(_data);
        })
    }
    renderGroup(tab_name,group,data,fields,style,defaultGridConfigs={},justify="flex-start"){
        //console.log("render group",tab_name,group,fields);
        if(group.html_component_input==="div"){
            return (
                <div>
                    <GroupTabs 
                        tab={tab_name}
                        inline={this.props.inline}
                        group={group.name} style={style}  
                        data={data} 
                        fields={fields}
                        justify ={justify}
                        defaultGridConfigs = {defaultGridConfigs}
                        showFieldName = {this.props.showFieldName}
                        readOnly={this.props.readOnly}
                        noValidate = {this.props.noValidate}
                        dataPickers = {this.props.dataPickers}
                        parent={this.props.parent}
                        mainForm={this.props.mainForm}
                        mediaQueryMatches ={this.props.mediaQueryMatches}
                        handleValueChanged={data=>this.handleValueChanged({},data)}/>
                </div>
            )
        }
        return (
            <div style={{paddingTop:15}}>
                <fieldset style={{borderRadius:4,marginBottom:5,borderWidth:1,borderColor:this.context.config.primaryColor,minWidth: 0}}>
                    <legend>{group.header}</legend>
                    <GroupTabs 
                        tab={tab_name}
                        inline={this.props.inline}
                        group={group.name} style={style}
                        data={data}
                        fields={fields}
                        justify ={justify}
                        readOnly={this.props.readOnly}
                        noValidate = {this.props.noValidate}
                        dataPickers = {this.props.dataPickers}
                        defaultGridConfigs = {defaultGridConfigs}
                        showFieldName={this.props.showFieldName}
                        parent={this.props.parent}
                        mainForm={this.props.mainForm}
                        mediaQueryMatches ={this.props.mediaQueryMatches}
                        handleValueChanged={data=>this.handleValueChanged({},data)}/>
                </fieldset>
            </div>
            
        )
    }
    getGridConfig(data,field,defaultGridConfigs={}){
        //handle header
        if(field.header_source && field.header_source.indexOf("return ")>=0 && field.header_source.indexOf("await")<0){
            let body_func = field.header_source;
            try{
                const func  = new Function("master","Moment","Numeral","API","utils","context","field","listInfo",body_func);
                let header =  func(data,moment,numeral,this.context.apis,utils,this.context,field,this.props.parent);
                field.header = header;
            }catch(e){
                console.error("getGridConfig",e.message,field.header_source);
            }
        }
        //handle gridconfigs
        let grid_md_default = (this.props?.parent?.state?.listInfo?.form_size==="lg" || this.props?.parent?.state?.listInfo?.form_size==="full")?3:6;
        let gridConfigs={...defaultGridConfigs};
        if(field.grid_configs){
            try{
                gridConfigs = (new Function("data","context","mediaQueryMatches",(field.grid_configs.includes("return ")?"":"return ") + field.grid_configs))(data,this.context,this.props.mediaQueryMatches) ;
            }catch(e){
                console.error(e.message,field.name,field.grid_configs);
                gridConfigs ={}
            }
        }
        if(field.grid_configs_required){
            gridConfigs = {...gridConfigs,...field.grid_configs_required};
        } 

        if(field.type!=="Action" && field.type!=="Picker"){
            if(!gridConfigs.xs) gridConfigs.xs = defaultGridConfigs.xs || 12;
            if(!gridConfigs.sm) gridConfigs.sm = defaultGridConfigs.sm || gridConfigs.xs;
            if(!gridConfigs.md) gridConfigs.md = defaultGridConfigs.md || grid_md_default;
            if(!gridConfigs.lg) gridConfigs.lg = defaultGridConfigs.lg || gridConfigs.md || grid_md_default;
        }
        return gridConfigs;
    }
    renderFields(tab_name,group_name,data,fields,style,defaultGridConfigs={},justify="flex-start"){
        const _fields = fields.filter(f=>f.tab === tab_name && f.group===group_name);
        let backgroundColor = (style||{}).backgroundColor;

        /*if(!backgroundColor && this.props.mediaQueryMatches && _fields.find(f=>f.type==="Array" && f.form )){
            backgroundColor = "#EBEBEB";
        }*/
        //create config
        const mainForm = this.props.mainForm;
        const self = this;
        _fields.forEach(field=>{
            if(field.type=="Mixed" && field.form ){
                if(!data[field.name]) data[field.name] ={};
            }
            if(field.type=="Array" && field.form ){
                if(!data[field.name]) data[field.name] =[];
            }
            if(field.type=="Action"){
                const f = field;
                const handler = async ()=>{
                    //this.context.setProgressStatus(true);
                    const data = mainForm && mainForm.getData?mainForm.getData():this.props.data;
                    const master = (mainForm && mainForm.getMaster?mainForm.getMaster():this.props.master)||data;
                    const parent = this.props.parent;
                    const mediaQueryMatches = this.props.mediaQueryMatches;
                    const context = this.context;
                    try{
                        let bodyFunction = `return (async ()=>{
                            ${f.default||"alert('Chưa khai báo xử lý hành động này')"}
                        })()`;
                        let action = new Function("master","data","API","context","parent","Moment","token","mediaQueryMatches","utils",bodyFunction);
                        let rs = await action(master,data,context.apis,context,parent,moment,(context.userInfo||{}).token,mediaQueryMatches,utils);
                        //this.context.setProgressStatus(false);
                        if(rs && typeof(rs)==="object"){
                            if(Object.keys(rs).length==1){
                                let field_changed = Object.keys(rs)[0];
                                if(field_changed){
                                    let f_changed = fields.find(f=>f.name==field_changed);
                                    if(f_changed){
                                        self.handleValueChanged(f_changed,rs);
                                    }else{
                                        self.handleValueChanged(f,rs);
                                    }
                                }else{
                                    self.handleValueChanged(f,rs);
                                }
                            }else{
                                self.handleValueChanged(f,rs);
                            }
                        }
                    }catch(e){
                        console.error(e,f.default);
                        self.context.alert(e.message);
                    }
                }
                field.handler = handler.bind(this);
            }
            field.__gridConfigs = this.getGridConfig(data,field,defaultGridConfigs)
            
        })
        //groups
        let gs =[];
        let g=[];
        _fields.forEach(f=>{
            if((f.type==="Array" && f.form) || (f.type=="Mixed" && f.form) || (f.type=="String" && (f.html_component_input==="editor" || f.html_component_input==="code"))){
                if(g.length>0){
                    gs.push([...g]);
                    g =[]
                }
                gs.push([f]);
            }else{
                g.push(f)
            }
        })
        if(g.length>0){
            gs.push(g);
        }
        return <div style={{...(style||{}),display:"flex",flexDirection:"column",backgroundColor}}>
            {gs.map((g,index)=>{
                let key = `${tab_name||""}-${group_name||""}-${index}`
                return this.renderChildrendFields(key,tab_name,data,g,_fields,fields,defaultGridConfigs,justify)
            })}
        </div>
        
    }
    renderChildrendFields(key,tab_name,data,fields,fields_tab_group,all_fields,defaultGridConfigs={},justify="flex-start"){
        const variant= this.props.mediaQueryMatches?"standard":"standard";
        const margin = this.props.mediaQueryMatches?"dense":"normal";

        let {public_token,id_app,server_url} = this.context.config;
        if(this.props.idApp){
            id_app = this.props.idApp;
        }
        let code_id_app;

        if(this.props.code && this.context.apis.list_not_require_id_app.indexOf(this.props.code)<0){
            code_id_app = id_app;
        }
        const _fields_render = fields.filter(f=>f.visible && !f.__gridConfigs.extraActionOfForm);

        if(_fields_render.length==0) return null;
        //render Inputbase
        if(_fields_render.length==1 && _fields_render[0].type=="Array" && _fields_render[0].form){
            let field = _fields_render[0];
            //console.log(field);
            if(!this.state.InputBase) return null;
            
            if(!data[field.name]) data[field.name] =[];
            let gridConfigs = this.getGridConfig(data,field,defaultGridConfigs)
            //let gridConfigs = field.__gridConfigs;

            let readOnly = this.props.readOnly || gridConfigs.disabled || gridConfigs.readOnly;
            //extra actions
            let extraActions = fields_tab_group.filter(f=>f.visible && f.__gridConfigs.extraActionOfForm==field.form).map(f=>{
                return <Button key={f.name} style={{...(f.__gridConfigs.style||{}),marginLeft:5}}  disabled={readOnly} variant= {f.__gridConfigs.variant || "outlined"} color={f.__gridConfigs.color || "primary"} onClick={f.handler}>{this.context.apis.getLabel(f.header)}</Button>
            })
            let _label = this.context.apis.getLabel(field.header) + (this.props.showFieldName?`{${field.name}:${field.type}}`:'');
            return (    
                <div style={{flex:1,overflow:"auto",display:"flex",flexDirection:"column"}} key={key}>
                    {fields_tab_group.filter(f=>f.visible && f.type!=="Action"  && f.type!=="Link").length>1 &&
                    <Typography component="div" variant="caption" class="InputLabel" style={{paddingLeft:(this.props.mediaQueryMatches?5:undefined)}}><span dangerouslySetInnerHTML={{__html: _label}}/> {field.required && <span>*</span>} </Typography>}
                    <div style={{flex:1,overflow:"auto"}}>
                        <this.state.InputBase
                            multiSel={false}
                            hideHeader
                            disabled={readOnly}
                            readOnly={readOnly}
                            history={this.props.history}
                            label={_label}
                            showFieldName={this.props.showFieldName}
                            formCode={field.form}
                            rows={data[field.name]}
                            master={data}
                            mediaQueryMatches ={this.props.mediaQueryMatches}
                            fullScreen={this.props.mediaQueryMatches && window.innerHeight<500}
                            style={{...(gridConfigs.style||{})}}
                            col_editable={((this.context.appInfo||{}).options||{}).col_editable}
                            isDetail={true}
                            optionsDataCode ={this.props.code}//sử dụng options của master
                            footerProps={{style:{paddingLeft:5}}}
                            bodyProps={{style:{paddingLeft:0,paddingRight:0}}}
                            extraActions={extraActions}
                            onRowsChanged = {(rows)=>{
                                this.handleValueChanged(field,{[field.name]:rows});
                            }}
                        />
                    </div>
                </div>
            )
        }
        //render children form
        if(_fields_render.length==1 && _fields_render[0].type=="Mixed" && _fields_render[0].form ){
            let field = _fields_render[0];
            if(!data[field.name]) data[field.name] ={};
            let gridConfigs = this.getGridConfig(data,field,defaultGridConfigs)
            //let gridConfigs = field.__gridConfigs;
            return (    
                <div  key={key}>
                    <FormBase
                        style={{margin:0,...(gridConfigs.style||{})}}
                        code={field.form}
                        showFieldName={this.props.showFieldName}
                        handleValueChanged = {_data=>this.handleValueChanged(field,{[field.name]:_data})}
                        data ={data[field.name]}
                        master={data}
                    />
                </div>
            )
        }
        //render editor
        if(_fields_render.length==1 && _fields_render[0].html_component_input=="editor"){
            let field = _fields_render[0];
            let gridConfigs = this.getGridConfig(data,field,defaultGridConfigs)
            //let gridConfigs = field.__gridConfigs;

            let readOnly = this.props.readOnly || gridConfigs.disabled || gridConfigs.readOnly;
            let multy_field_yn = fields_tab_group.filter(f=>f.visible).length>1;
            let _label = this.context.apis.getLabel(field.header) + (this.props.showFieldName?`{${field.name}:${field.type}}`:'');
            return (    
                <div  key={key}  style={{padding:multy_field_yn?5:0}} >
                    {multy_field_yn &&
                    <Typography component="div" variant="caption" class="InputLabel"><span dangerouslySetInnerHTML={{__html: _label}}/> {field.required && <span>*</span>} </Typography>}
                    <HtmlEditor
                        style={gridConfigs.style}
                        data={data[field.name]}
                        obj = {data}
                        disabled={readOnly}
                        helperText={(field.help_text||'').toString()}
                        autoFocus={gridConfigs.autoFocus}
                        onChange={ ( event, _data ) => {
                            this.handleValueChanged(field,{[field.name]:_data})
                        }}
                    />
                </div>
            )
        }
        //render code
        if(_fields_render.length==1 && _fields_render[0].html_component_input=="code"){
            let field = _fields_render[0];
            let gridConfigs = this.getGridConfig(data,field,defaultGridConfigs)
            //let gridConfigs = field.__gridConfigs;
            let readOnly = this.props.readOnly || gridConfigs.disabled || gridConfigs.readOnly;
            let multy_field_yn = fields_tab_group.filter(f=>f.visible).length>1;
            let _label = this.context.apis.getLabel(field.header) + (this.props.showFieldName?`{${field.name}:${field.type}}`:'')
            return (    
                <div  key={key}  style={{padding:multy_field_yn?5:0}} >
                    {multy_field_yn &&
                    <Typography component="div" variant="caption" class="InputLabel">
                        <span dangerouslySetInnerHTML={{__html: _label}}/> {field.required && <span>*</span>} 
                    </Typography>}
                    <CodeEditor
                        style={gridConfigs.style}
                        data={data[field.name]}
                        obj = {data}
                        disabled={readOnly}
                        autoFocus={gridConfigs.autoFocus}
                        helperText={(field.help_text||'').toString()}
                        onChange={ ( event, _data ) => {
                            this.handleValueChanged(field,{[field.name]:_data})
                        }}
                    />
                </div>
            )
        }
        //render other components
        return (
            <div style={{padding:5}}  key={key}>
                <Grid container spacing={0} justifyContent={justify} wrap={this.props.inline?"nowrap":undefined} style={{/*minWidth:this.props.inline?_fields_render.length*200:undefined*/}} >
                    {_fields_render.map(field=>{
                        if(this.props.dataPickers && this.props.dataPickers[field.name]){
                            field.html_component_input="picker";
                            field.ref_model = this.props.dataPickers[field.name];
                            field.ref_field = field.ref_field||"code";
                            field.ref_label = field.ref_label||"label";
                        }else{
                            if((field.html_component_input=="autocomplete" || field.html_component_input=="picker")  && !field.ref_model){
                                field.html_component_input ="";
                            }
                            if(field.ref_model && (!field.html_component_input)){
                                if((!field.multiple && (field.ref_model.includes("[") || field.ref_model.includes(","))) || field.ref_model=="trangthai"){
                                    field.html_component_input="picker";
                                }else{
                                    field.html_component_input="autocomplete";
                                }
                            }
                        }
                        let gridConfigs = this.getGridConfig(data,field,defaultGridConfigs)
                        if(this.props.inline && gridConfigs.inline_hide) return null;

                        //let gridConfigs = field.__gridConfigs;
                        //
                        let readOnly = this.props.readOnly || gridConfigs.disabled || gridConfigs.readOnly;
                        const InputProps_mediaQueryMatches = (this.props.mediaQueryMatches || this.context.config?.isMobile)? {
                            disableUnderline:true,
                            style:{padding:5,border:"1px solid #B9B9B9",borderRadius:3,display:"flex",flexDirection:"row",alignItems:"center",backgroundColor:readOnly?'#f5f5f5':undefined}
                        }:{};

                        let _props = {...gridConfigs}
                        if(this.props.mediaQueryMatches){
                            _props = {..._props,lg:12,md:12}
                        }
                        //Tạo gridsize từ config
                        if(!_props.gridSize && (_props.md || _props.lg || _props.sm || _props.xs || _props.xl)){
                            _props.gridSize={
                                xs: _props.xs,
                                sm: _props.sm,
                                md: _props.md,
                                lg: _props.lg,
                                xl: _props.xl || _props.lg
                            }
                        }
                        const gridSize = _props.gridSize;
                        //xoá các property cũ
                        delete _props.gridSize;
                        delete _props.xs;
                        delete _props.sm;
                        delete _props.md;
                        delete _props.lg;
                        delete _props.xl;
                        delete _props.size;
                        delete _props.maxWidth;
                        delete _props.style;//style trong gridconfig là dành cho component con
                        //console.log("[grouptabs] grid of ",field.name,_props)
                        //
                        let paddingRight =this.props.mediaQueryMatches?0:10;//( _props.xs==12 || _props.sm==12)?0:10

                        let _label = this.props.mediaQueryMatches && _fields_render.length==1 && tab_name && !this.props.showFieldName && !field.required?undefined:this.context.apis.getLabel(field.header);
                        
                        if(_label && this.props.showFieldName){
                            _label = _label + `{${field.name}:${field.type}}`;
                        }
                        
                        switch (field.type) {
                        case "Group":{
                            return (
                            <Grid   {..._props} size={gridSize}    key={field.name} style={{paddingRight}}>
                                {this.renderGroup(tab_name,field,data,all_fields,gridConfigs.style,defaultGridConfigs={},justify="flex-start")}
                            </Grid>
                            )
                        }
                        case "Date":
                            return (
                            <Grid   {..._props} size={gridSize}  key={field.name} style={{paddingRight}}>
                                <ManagedDropdown type="datepicker"
                                    label={_label}
                                    value={data[field.name]?moment(data[field.name]) : null}
                                    onChange={d=>this.handleValueChanged(field,{[field.name]:d?d.toDate():null})}

                                    format={field.format || "DD/MM/YYYY"}
                                    readOnly={readOnly}
                                    disabled={gridConfigs && gridConfigs.disabled}
                                    showTodayButton
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            margin: margin,
                                            variant: variant,
                                            style: gridConfigs && gridConfigs.style,
                                            InputLabelProps: { shrink: true },
                                            placeholder: (this.props.inline?_label+" :":"") + (field.format || "DD/MM/YYYY"),
                                            required: field.required && !this.props.noValidate?true:false,
                                            helperText: (field.help_text || '').toString(),
                                            autoFocus: gridConfigs && gridConfigs.autoFocus,
                                            
                                            InputProps: {
                                                readOnly: readOnly, // readOnly cho input field
                                                ...InputProps_mediaQueryMatches
                                            },
                                        },
                                        
                                        openPickerButton: {
                                            'aria-label': 'change date time',
                                        },
                                        
                                    }}
                                />
                                
                            </Grid>
                            )
                        case "DateTime":
                            return (
                            <Grid   {..._props} size={gridSize}  key={field.name} style={{paddingRight}}>
                                <ManagedDropdown type="datetimepicker"
                                    label={_label}
                                    value={data[field.name]?moment(data[field.name]) : null}
                                    onChange={d=>this.handleValueChanged(field,{[field.name]:d?d.toDate():null})}

                                    format={field.format || "DD/MM/YYYY HH:mm A"}
                                    readOnly={readOnly}
                                    disabled={gridConfigs && gridConfigs.disabled}
                                    showTodayButton
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            margin: margin,
                                            variant: variant,
                                            style: gridConfigs && gridConfigs.style,
                                            InputLabelProps: { shrink: true },
                                            placeholder: (this.props.inline?_label+" :":"") + (field.format || "DD/MM/YYYY HH:mm A"),
                                            required: field.required && !this.props.noValidate?true:false,
                                            helperText: (field.help_text || '').toString(),
                                            autoFocus: gridConfigs && gridConfigs.autoFocus,
                                            // InputProps cũng có thể được đặt ở đây nếu cần
                                            InputProps: {
                                                readOnly: readOnly, // readOnly cho input field
                                                ...InputProps_mediaQueryMatches
                                            },
                                        },
                                        // Tùy chỉnh nút mở picker (thay cho KeyboardButtonProps)
                                        openPickerButton: {
                                            'aria-label': 'change date time',
                                        },
                                        // Các slot khác có thể tùy chỉnh: day, month, year, actionBar, etc.
                                    }}
                                />
                            </Grid>
                            )
                        case "Time":
                            return (
                            <Grid   {..._props} size={gridSize}  key={field.name} style={{paddingRight}}>
                               <ManagedDropdown type="timepicker"
                                    label={_label}
                                    value={data[field.name]?moment(data[field.name]) : null}
                                    onChange={d=>this.handleValueChanged(field,{[field.name]:d?d.toDate():null})}

                                    format={field.format || "HH:mm A"} // format vẫn được hỗ trợ
                                    readOnly={readOnly}
                                    disabled={gridConfigs && gridConfigs.disabled}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            margin: margin,
                                            variant: variant,
                                            style: gridConfigs && gridConfigs.style,
                                            InputLabelProps: { shrink: true },
                                            placeholder: (this.props.inline?_label+" :":"") + (field.format || "HH:mm A"),
                                            required: field.required && !this.props.noValidate?true:false,
                                            helperText: (field.help_text || '').toString(),
                                            autoFocus: gridConfigs && gridConfigs.autoFocus,
                                            // InputProps cũng có thể được đặt ở đây nếu cần
                                            InputProps: {
                                                readOnly: readOnly, // readOnly cho input field
                                                ...InputProps_mediaQueryMatches
                                            },
                                        },
                                        // Tùy chỉnh nút mở picker (thay cho KeyboardButtonProps)
                                        openPickerButton: {
                                            'aria-label': 'change date time',
                                        },
                                        // Các slot khác có thể tùy chỉnh: day, month, year, actionBar, etc.
                                    }}
                                />
                            </Grid>
                            )
                        case "Boolean":
                            return (
                            <Grid   {..._props}  size={gridSize}  key={field.name} style={{paddingRight,display:"flex",flexDirection:"column",justifyContent:"flex-end"}}>
                                <Checkbox  style={gridConfigs.style}
                                    label={_label} 
                                    disabled={readOnly} 
                                    readOnly = {readOnly} value={data[field.name]} 
                                    onChange={(event)=>this.handleValueChanged(field,{[field.name]:event.target.checked})}/>
                            </Grid>
                            )
                        case "Mixed":{
                            if(field.html_component_input=="checkboxlist"){
                                if(!data[field.name]) data[field.name] = {}
                                try{
                                    if(field.ref_model){
                                        let _condition = getRefCondition(this.props.master,data,field,this.context.userInfo?this.context.getToken():public_token,this.context.apis,this.context,this.props.code);
                                        return (
                                            <Grid   {..._props}  size={gridSize}  key={field.name} style={{paddingRight}}>
                                                <CheckboxList 
                                                    field={field} 
                                                    value={cloneDeep(data[field.name])} 
                                                    readOnly={readOnly}
                                                    codeField={field.ref_field||"code"}
                                                    titleField={field.ref_label || field.ref_field ||"title"}
                                                    condition={_condition}
                                                    mediaQueryMatches ={this.props.mediaQueryMatches}
                                                    items={async (query)=>{
                                                        if(field.ref_model.indexOf("{")>=0){
                                                            try{
                                                                return (new Function(`return ${field.ref_model}`))();
                                                            }catch(e){
                                                                console.error(e.message,field.ref_model);
                                                                return [];
                                                            }
                                                        }else{
                                                            let token = this.context.userInfo?this.context.getToken():public_token;
                                                            let model = field.ref_model;
                                                            if(model==="dmtk") model ="account";
                                                            if(model==="dmkh") model ="customer";
                                                            if(model==="dmnt") model ="currency";
                                                            let fields;
                                                            if(!field.handle_value_changed || field.ref_data_fields || field.ref_search_fields){
                                                                fields = (field.ref_data_fields || field.ref_search_fields  || field.ref_field) + ",bac,loai_nh";
        
                                                                if(fields.indexOf(field.ref_field)<0){
                                                                    fields = `${fields},${field.ref_field}`;
                                                                }
                                                                if(field.ref_label && fields.indexOf(field.ref_label)<0){
                                                                    fields = `${fields},${field.ref_label}`;
                                                                }
                                                            }
                                                            try{
                                                                //console.log("idApp",this.props.idApp);
                                                                return await this.context.apis.asyncGetList(token,model,{id_app:this.props.idApp,condition:query,fields,limit:1000,id_app:this.props.idApp})
                                                            }catch(e){
                                                                console.error(e);
                                                                return []
                                                            }
                                                            
                                                            
                                                        }
                                                    }}
                                                    onChange={(_data)=>{
                                                        this.handleValueChanged(field,{[field.name]:_data})
                                                    }}
                                                />
                                            </Grid>
                                        )
                                        
                                    }
                                }catch(e){
                                    console.error(e,field.ref_mode);
                                }
                            }
                            return null
                        }
                        case "Files":{
                            let id_link =  data._id || data.__id_tmp__;
                            if(!id_link){
                                id_link = data.__id_tmp__ = `__tmp__${new Date().getTime()}`
                            }
                            return (
                                <Grid  {..._props}  size={gridSize}   key={field.name} style={{padding:0,margin:0}}>
                                    <Files 
                                        style={gridConfigs.style}
                                        typeView="list"
                                        onFilesChanged = {files=>{
                                            if(!data._id){
                                                const exfields = data.exfields|| {};
                                                exfields.__files__ = files;
                                                this.handleValueChanged(field,{exfields})
                                            }
                                        }}
                                        mediaQueryMatches ={this.props.mediaQueryMatches}
                                        idLink ={id_link}
                                    />
                                </Grid>
                                
                            )
                        }
                        case "Link":
                            return null
                        case "Action":{
                            //la extraaction cua other form
                            if(gridConfigs.extraActionOfForm){
                                return null;
                            }
                            const handler = field.handler
                            //
                            if(gridConfigs.id_container){
                                let actionsContainer = document.getElementById(gridConfigs.id_container);
                                if(actionsContainer){
                                    return (
                                        <Portal container={actionsContainer}>
                                            <Button key={field.name} style={{...(gridConfigs.style||{}),marginRight:5}}  disabled={readOnly} variant= {gridConfigs.variant || "outlined"} color={gridConfigs.color || "primary"} onClick={handler}>{this.context.apis.getLabel(field.header)}</Button>
                                        </Portal>
                                    )
                                }
                            }
                            return (
                                gridSize?
                                    <Grid   {..._props}  size={gridSize}  key={field.name} style={{margin:0,display:"flex",flexDirection:"column",justifyContent:"flex-end"}}>
                                        <Button style={{...(gridConfigs.style||{})}}  disabled={readOnly} variant= {gridConfigs.variant || "outlined"} color={gridConfigs.color || "primary"} onClick={handler}>{this.context.apis.getLabel(field.header)}</Button>
                                    </Grid>
                                :
                                    <Button key={field.name} style={{...(gridConfigs.style||{}),marginRight:5}}  disabled={readOnly} variant= {gridConfigs.variant || "outlined"} color={gridConfigs.color || "primary"} onClick={handler}>{this.context.apis.getLabel(field.header)}</Button>

                            )
                        }
                        case "Picker":{
                            let handler = async ()=>{
                                if(!field.ref_model) return this.context.alert(this.context.apis.getLabel("Chưa khai báo model của picker"));
                                let condition = await getRefCondition(this.props.master,data,field,this.context.userInfo?this.context.getToken():this.context.config.public_token,this.context.apis,this.context,this.props.code);
                                this.refObjectPicker.open(field.ref_model,this.context.apis.getLabel(field.header),async (selected)=>{
                                    const valueSelected ={[field.name]:selected[field.ref_value||field.name]};
                                    this.handleValueChanged(field,valueSelected,selected);
                                },condition);
                            }
                            return (
                                (_props.size)?
                                <Grid   {..._props}  size={gridSize}  key={field.name} style={{margin:0}}>
                                    <Button style={{...(gridConfigs.style||{})}}  disabled={readOnly} variant= {gridConfigs.variant || "outlined"} color={gridConfigs.color || "secondary"} onClick={handler.bind(this)}>{this.context.apis.getLabel(field.header)}</Button>
                                </Grid>
                                :
                                <Button  key={field.name} style={{...(gridConfigs.style||{})}}  disabled={readOnly} variant= {gridConfigs.variant || "outlined"} color={gridConfigs.color || "secondary"} onClick={handler.bind(this)}>{this.context.apis.getLabel(field.header)}</Button>

                            )
                        }
                        case "File":
                            return(
                            <Grid  {..._props}  size={gridSize} key={field.name} style={{paddingRight}}>
                                <div  style={{display:"flex",alignItems:"center",...(gridConfigs.style || {})}}>
                                    {!!_label && <Typography class="InputLabel"  style={(gridConfigs.InputLabelProps||{}).style}>{_label} {field.required && <span> *</span>}</Typography>}
                                    {!!data[field.name] && 
                                        <>
                                            <div style={{marginTop:10,position:"relative"}}>
                                                <Button style={{marginLeft:5}} variant={gridConfigs.variant || "outlined"} onClick={()=>this.download(`${server_url}${data[field.name]}`)}><DownloadIcon/> <Typography>{this.context.apis.getLabel("Tải về")}</Typography></Button>
                                                
                                                <Button variant={gridConfigs.variant || "outlined"} style={{marginLeft:10}} onClick={()=>{
                                                    this.handleValueChanged(field,{[field.name]:null});
                                                }}><RemoveCircle/> <Typography>{this.context.apis.getLabel("Xóa")}</Typography></Button>
                                            </div>
                                            
                                        </>
                                    }
                                    
                                    {!data[field.name] &&  
                                    <Button size="small" color={gridConfigs.color || "secondary"} variant={!data[field.name]?gridConfigs.variant || "outlined":undefined} component="label" style={{marginLeft:10}} disabled={this.props.readOnly || gridConfigs.disabled || gridConfigs.readOnly}>
                                        <UploadIcon/> {this.context.apis.getLabel("Tải lên")}
                                        <input
                                            type="file"
                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                            style={{ display: "none" }}
                                            onChange={event=>{
                                                const files = event.target.files;
                                                if(files.length>0){
                                                    if(code_id_app){
                                                        let url = server_url + "/api/" + id_app + "/file?json=1&access_token=" + this.context.getToken();
                                                        this.context.setProgressStatus(true);
                                                        let data ={id_app:code_id_app,group:this.props.code};
                                                        data.name ="file";
                                                        this.context.apis.uploadFile(url,files[0],(error,rs)=>{
                                                            this.context.setProgressStatus(false);
                                                            if(error) return this.context.alert(error.message);
                                                            rs = JSON.parse(rs);
                                                            let fileUrl = `/api/${this.props.idApp || this.context.config.id_app}/file/download/${rs._id}`
                                                            this.handleValueChanged(field,{[field.name]:fileUrl});
                                                        },data)
                                                    }else{
                                                        let url = server_url + "/api/uploadexcel?json=1&access_token=" + this.context.getToken();
                                                        this.context.setProgressStatus(true);
                                                        this.context.apis.uploadFile(url,files[0],(error,rs)=>{
                                                            this.context.setProgressStatus(false);
                                                            if(error) return this.context.alert(error.message);
                                                            rs = JSON.parse(rs);
                                                            this.handleValueChanged(field,{[field.name]:rs.fileUrl});
                                                        })
                                                    }
                                                }
                                            }}
                                        />
                                    </Button>}
                                </div>
                                
                                
                            </Grid>
                            )
                        case "Pdf":
                            return(
                            <Grid   {..._props} size={gridSize} key={field.name} style={{paddingRight}}>
                                <div  style={{display:"flex",alignItems:"center",...(gridConfigs.style||{})}}>
                                    {!!_label &&  <Typography class="InputLabel"  style={(gridConfigs.InputLabelProps||{}).style}>{_label} {field.required && <span>*</span>} </Typography>}
                                    
                                    {!!data[field.name] && 
                                        <>
                                            <div style={{marginTop:10,position:"relative"}}>
                                                <Button style={{marginLeft:5}} variant={gridConfigs.variant || "outlined"} onClick={()=>this.download(`${server_url}${data[field.name]}`)}><DownloadIcon/> <Typography>{this.context.apis.getLabel("Tải về")}</Typography></Button>
                                                
                                                <Button variant={gridConfigs.variant || "outlined"} style={{marginLeft:10}} onClick={()=>{
                                                    this.handleValueChanged(field,{[field.name]:null});
                                                }}><RemoveCircle/> <Typography>{this.context.apis.getLabel("Xóa")}</Typography></Button>
                                            </div>
                                            
                                        </>
                                    }
                                    
                                    {!data[field.name] &&  
                                    <Button size="small"  color={gridConfigs.color || "secondary"}  disabled={readOnly} variant={!data[field.name]?gridConfigs.variant || "outlined":undefined} component="label" style={{marginLeft:10}}>
                                        <UploadIcon/> {this.context.apis.getLabel("Tải lên")}
                                        <input
                                            type="file"
                                            accept="application/pdf"
                                            style={{ display: "none" }}
                                            onChange={event=>{
                                            const files = event.target.files;
                                            if(files.length>0){
                                                if(code_id_app){
                                                    let url = server_url + "/api/" + id_app + "/file?json=1&access_token=" + this.context.getToken();
                                                    this.context.setProgressStatus(true);
                                                    let data ={id_app:code_id_app,group:this.props.code};
                                                    data.name ="file";
                                                    this.context.apis.uploadFile(url,files[0],(error,rs)=>{
                                                        this.context.setProgressStatus(false);
                                                        if(error) return this.context.alert(error.message);
                                                        rs = JSON.parse(rs);
                                                        let fileUrl = `/api/${this.props.idApp || this.context.config.id_app}/file/download/${rs._id}`
                                                        this.handleValueChanged(field,{[field.name]:fileUrl});
                                                    },data)
                                                }else{
                                                    let url = `${server_url}/api/uploadfile?json=1&folder=${this.props.code||'pdf'}&access_token=${this.context.getToken()}`;
                                                    this.context.setProgressStatus(true);
                                                    console.log("upload pdf file",files[0]);
                                                    this.context.apis.uploadFile(url,files[0],(error,rs)=>{
                                                        this.context.setProgressStatus(false);
                                                        if(error) return this.context.alert(error.message);
                                                        rs = JSON.parse(rs);
                                                        this.handleValueChanged(field,{[field.name]:rs.fileUrl});
                                                    })
                                                }
                                            }
                                            }}
                                        />
                                    </Button>}
                                </div>
                            </Grid>
                            )
                        case "Image":{
                            let url = data[field.name]?(data[field.name].indexOf("http")===0?data[field.name]:`${server_url}${data[field.name]}?size=S&access_token=${this.context.getToken()}`):null
                            return(
                            <Grid   {..._props} size={gridSize} key={field.name} style={{paddingRight,display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",overflow:"hidden"}}>
                                {!!_label && <Typography variant="caption" component="div" class="InputLabel"  style={{textAlign:"center",transformOrigin:"unset",margin:5,...(gridConfigs.InputLabelProps||{}).style}}>{_label} {field.required && <span>*</span>}</Typography>}
                                <div style={{marginTop:10,position:"relative"}}>
                                    <Button color={gridConfigs.color || "secondary"} disabled={readOnly} variant={data[field.name]?"text":(gridConfigs.variant || "outlined")} component="label">
                                        {data[field.name]?
                                            <SecureImage src={url} canFullView  effect="blur" style={{marginTop:10,maxHeight:128,maxWidth:128,objectFit:"contain"}}/>
                                            :
                                            <><UploadIcon/> {this.context.apis.getLabel("Chọn hình ảnh")}</>
                                        }
                                        {!data[field.name] &&
                                        <input
                                            type="file"
                                            accept="image/*"
                                            style={{ display: "none" }}
                                            onChange={event=>{
                                                const files = event.target.files;
                                                if(files.length>0){
                                                    if(code_id_app){
                                                        let url = server_url + "/api/" + id_app + "/file?json=1&access_token=" + this.context.getToken();
                                                        this.context.setProgressStatus(true);
                                                        let data ={id_app:code_id_app,group:this.props.code};
                                                        data.name ="file";
                                                        this.context.apis.uploadFile(url,files[0],(error,rs)=>{
                                                            this.context.setProgressStatus(false);
                                                            if(error) return this.context.alert(error.message);
                                                            rs = JSON.parse(rs);
                                                            let fileUrl = `/api/${this.props.idApp || this.context.config.id_app}/file/download/${rs._id}`
                                                            this.handleValueChanged(field,{[field.name]:fileUrl});
                                                        },data)
                                                    }else{
                                                        let url = `${server_url}/api/uploadfile?json=1&folder=${this.props.code||'upload'}&access_token=${this.context.getToken()}`;
                                                        this.context.setProgressStatus(true);
                                                        this.context.apis.uploadFile(url,files[0],(error,rs)=>{
                                                            this.context.setProgressStatus(false);
                                                            if(error) return this.context.alert(error.message);
                                                            rs = JSON.parse(rs);
                                                            this.handleValueChanged(field,{[field.name]:rs.fileUrl});
                                                        })
                                                    }
                                                    
                                                }
                                            }}
                                        />}
                                    </Button>
                                    {!!data[field.name] && <IconButton size="small" style={{position:"absolute",right:3,top:3}} onClick={()=>{
                                        this.handleValueChanged(field,{[field.name]:null});
                                    }}>X</IconButton>}
                                </div>
                                
                            </Grid>
                        )}
                        case "OtherFile":
                            return(
                                <Grid   {..._props} size={gridSize}  key={field.name} style={{paddingRight}}>
                                    <div style={{display:"flex",alignItems:"center",...(gridConfigs.style||{})}}>
                                        {!!_label && <Typography class="InputLabel"  style={(gridConfigs.InputLabelProps||{}).style}>{_label}  {field.required && <span>*</span>} </Typography>}
                                        {!!data[field.name] && 
                                            <>
                                                <div style={{marginTop:10,position:"relative"}}>
                                                    <Button style={{marginLeft:5}} variant={gridConfigs.variant || "outlined"} onClick={()=>this.download(`${server_url}${data[field.name]}`)}><DownloadIcon/> <Typography>{this.context.apis.getLabel("Tải về")}</Typography></Button>
                                                    
                                                    <Button variant={gridConfigs.variant || "outlined"} style={{marginLeft:10}} onClick={()=>{
                                                        this.handleValueChanged(field,{[field.name]:null});
                                                    }}><RemoveCircle/> <Typography>{this.context.apis.getLabel("Xóa")}</Typography></Button>
                                                </div>
                                                
                                            </>
                                        }
                                        {!data[field.name] &&  
                                        <Button    color={gridConfigs.color || "secondary"}   variant={"outlined"} component="label" style={{marginLeft:10}} disabled={readOnly}>
                                            <UploadIcon/> {this.context.apis.getLabel("Tải lên")}
                                            <input
                                                type="file"
                                                style={{ display: "none" }}
                                                onChange={event=>{
                                                    const files = event.target.files;
                                                    if(files.length>0){
                                                        if(code_id_app){
                                                            let url = server_url + "/api/" + id_app + "/file?json=1&access_token=" + this.context.getToken();
                                                            this.context.setProgressStatus(true);
                                                            let data ={id_app:code_id_app,group:this.props.code};
                                                            data.name ="file";
                                                            this.context.apis.uploadFile(url,files[0],(error,rs)=>{
                                                                this.context.setProgressStatus(false);
                                                                if(error) return this.context.alert(error.message);
                                                                rs = JSON.parse(rs);
                                                                let fileUrl = `/api/${this.props.idApp || this.context.config.id_app}/file/download/${rs._id}`
                                                                this.handleValueChanged(field,{[field.name]:fileUrl});
                                                            },data)
                                                        }else{
                                                            let url = `${server_url}/api/uploadfile?json=1&folder=${this.props.code||'anytype'}&access_token=${this.context.getToken()}`;
                                                            this.context.setProgressStatus(true);
                                                            this.context.apis.uploadFile(url,files[0],(error,rs)=>{
                                                                this.context.setProgressStatus(false);
                                                                if(error) return this.context.alert(error.message);
                                                                rs = JSON.parse(rs);
                                                                this.handleValueChanged(field,{[field.name]:rs.fileUrl});
                                                            })
                                                        }
                                                        

                                                        

                                                    }}
                                                }
                                            />
                                        </Button>}
                                    </div>
                                </Grid>
                            )
                        default:{
                            switch (field.html_component_input) {
                            case "textarea":
                                return (
                                    <Grid   {..._props} size={gridSize}   key={field.name} style={{paddingRight}}>
                                        <TextField
                                            inline={this.props.inline}
                                            field={field}
                                            style={gridConfigs.style}
                                            margin={margin}
                                            required={field.required && !this.props.noValidate?true:false}
                                            fullWidth
                                            multiline
                                            minRows={this.props.mediaQueryMatches?3:1}
                                            label={_label}
                                            variant={variant}
                                            value={data[field.name]||""}
                                            data={data}
                                            disabled={gridConfigs.disabled}
                                            InputLabelProps={{ shrink: true,...(gridConfigs||{}).InputLabelProps }}
                                            helperText={(field.help_text||'').toString()}
                                            mediaQueryMatches ={this.props.mediaQueryMatches}
                                            readOnly={readOnly}
                                            autoFocus={gridConfigs.autoFocus}
                                            inputProps={(gridConfigs||{}).inputProps}
                                            InputProps={{
                                                readOnly: readOnly,
                                                maxLength: field.maxlength,
                                                autoFocus:gridConfigs.autoFocus,
                                                ...((gridConfigs||{}).InputProps||{}),
                                                ...InputProps_mediaQueryMatches
                                                
                                            }}
                                            onChange={(event)=>this.handleValueChanged(field,{[field.name]:field.uppercase?(event.target.value||"").toUpperCase():event.target.value})}
                                        />
                                    </Grid>
                                )
                                
                            case "picker":{
                                if(field.ref_model && !Array.isArray(field.ref_model) && field.ref_model.includes(",") && !field.ref_model.includes("[")){
                                    field.ref_model = field.ref_model.split(",").map((ele,index)=>({index:index,value:ele.trim()}));
                                    if(!field.ref_field) field.ref_field ="value";
                                }
                                if(field.ref_model && field.ref_field){
                                    let _condition = getRefCondition(this.props.master,data,field,this.context.userInfo?this.context.getToken():public_token,this.context.apis,this.context,this.props.code);
                                    
                                    return (
                                        <Grid  {..._props}  size={gridSize}   key={field.name} style={{paddingRight}}>
                                            <Picker
                                                inline={this.props.inline}
                                                style={gridConfigs.style}
                                                id={"id-" + field.name}
                                                fullWidth
                                                margin={margin}
                                                dataType={field.type}
                                                required={field.required && !this.props.noValidate?true:false}
                                                value={data[field.name]}
                                                valueField={field.ref_field}
                                                labelField={field.ref_label}
                                                disabled={gridConfigs.disabled}
                                                isRadio={gridConfigs.isRadio}
                                                inputLabel={_label}
                                                readOnly= {readOnly}
                                                condition={_condition}
                                                variant={variant}
                                                masterData={{master:this.props.master,data,id_app: this.props.idApp}}
                                                helperText={(field.help_text||'').toString()}
                                                items={async (query,options)=>{
                                                    return getItemsForPicker(this.context,this.props.idApp,field,query,options,this.props.master);
                                                }}
                                                onValueChanged={(value,label,ref_data)=>{
                                                    let data={[field.name]:value}
                                                    if(field.ref_label_as || field.ref_label){
                                                        data[field.ref_label_as||field.ref_label] = label;
                                                    }
                                                    this.handleValueChanged(field,data,ref_data)
                                                }}
                                                mediaQueryMatches ={this.props.mediaQueryMatches}
                                            />
                                        </Grid>
                                    )
                                }
                                break;
                            }
                            case "autocomplete":{
                                if(field.ref_model && !Array.isArray(field.ref_model)  && field.ref_model.includes(",") && !field.ref_model.includes("[")>0){
                                    field.ref_model = field.ref_model.split(",").map((ele,index)=>({index:index,value:ele.trim()}));
                                    if(!field.ref_field) field.ref_field ="value"; 
                                }
                                if(field.ref_model && field.ref_field){
                                    let _condition = getRefCondition(this.props.master,data,field,this.context.userInfo?this.context.getToken():public_token,this.context.apis,this.context,this.props.code);
                                    
                                    let _field_label = (field.ref_label_as||field.ref_label);
                                    if(_field_label && !all_fields.find(f=>f.name===_field_label)){
                                        _field_label = ""
                                    }

                                    if(field.ref_search_fields && field.ref_field!=="_id" && field.ref_search_fields.indexOf(field.ref_field)<0){
                                        field.ref_search_fields = `${field.ref_search_fields},${field.ref_field}`;
                                    }

                                    if(field.ref_model === "customer" || field.ref_model === "supply"){
                                        field.ref_search_fields = field.ref_search_fields || `${field.ref_field}`;
                                        if(field.ref_search_fields.indexOf("ten_kh")<0){
                                            field.ref_search_fields = `${field.ref_search_fields},ten_kh`;
                                        }

                                        if(field.ref_search_fields.indexOf("dia_chi")<0){
                                            field.ref_search_fields = `${field.ref_search_fields},dia_chi`;
                                        }

                                        /*if(field.ref_search_fields?.indexOf("dien_thoai")<0){
                                            field.ref_search_fields = `${field.ref_search_fields},dien_thoai`;
                                        }
                                        if(field.ref_search_fields?.indexOf("ma_so_thue")<0){
                                            field.ref_search_fields = `${field.ref_search_fields},ma_so_thue`;
                                        }*/
                                    }

                                    if(field.ref_model === "dmvt"){
                                        field.ref_search_fields = field.ref_search_fields || `${field.ref_field}`;
                                        if(field.ref_search_fields.indexOf("ten_vt")<0){
                                            field.ref_search_fields = `${field.ref_search_fields},ten_vt`;
                                        }
                                        if(field.ref_search_fields.indexOf("ten_vt2")<0){
                                            field.ref_search_fields = `${field.ref_search_fields},ten_vt2`;
                                        }
                                    } 

                                    return (
                                        <Grid {..._props} size={gridSize}     key={field.name} style={{paddingRight}}>
                                            <AutoCompleteInput
                                                inline={this.props.inline}
                                                style={gridConfigs.style}
                                                id={"id-" + field.name}
                                                fullWidth
                                                variant={variant}
                                                margin={margin}
                                                multiple = {field.multiple}
                                                inputLabel={_label}
                                                required={field.required && !this.props.noValidate?true:false}
                                                masterData={{master:this.props.master,data,id_app: this.props.idApp}}
                                                value={data[field.name]}
                                                label={(field.ref_label_as||field.ref_label)?data[field.ref_label_as||field.ref_label]:null}
                                                model={field.ref_model.indexOf("{")>=0?null:field.ref_model}

                                                condition={_condition}
                                                valueField={field.ref_field}
                                                labelField={field.ref_label}
                                                field4Search={field.ref_search_fields}
                                                helperText={(field.help_text||'').toString()}
                                                getOptionLabel={option=>{
                                                    let label = option[field.ref_label || field.ref_field]||"";
                                                    let value = (option[field.ref_field]||"").toString();
                                                    if(field.ref_model==="account" || _field_label){
                                                        return `${value}`;
                                                    }else{
                                                        return `${label}`;
                                                    }
                                                }}
                                                disabled={gridConfigs.disabled}
                                                readOnly={readOnly}
                                                autoFocus={gridConfigs.autoFocus}
                                                notAdd={gridConfigs.notAdd}
                                                items={async (query,options={cache:false,limit:20,online:true})=>{
                                                    return getItemsForCompoleteInput(this.context,this.props.idApp,field,query,options,this.props.master);
                                                }}
                                                onValueChanged={(value,label,ref_data)=>{
                                                    let data={[field.name]:value}
                                                    if(field.ref_label_as||field.ref_label){
                                                        data[field.ref_label_as||field.ref_label] = label;
                                                    }
                                                    this.handleValueChanged(field,data,ref_data)
                                                }}
                                                mediaQueryMatches ={this.props.mediaQueryMatches}
                                            />
                                           
                                        </Grid>
                                    )
                                }
                                break;
                            }
                            case "html":{
                                return  <Grid  {..._props} size={gridSize}     key={field.name} style={{paddingRight}}>
                                    <div dangerouslySetInnerHTML={{__html: data[field.name]||""}}/>
                                </Grid>
                            }
                            case "bienthe":{
                                return <BienThe product={data} onValueChanged={(value,thuoc_tinh)=>{
                                    let data={[field.name]:value,thuoc_tinh}
                                    this.handleValueChanged(field,data)
                                }}/>
                            }

                            default:{
                                if(field.type === "Number"){
                                    field.min = field.min || gridConfigs.min;
                                    field.max = field.max || gridConfigs.max;
                                    return(
                                        <Grid {..._props} size={gridSize}      key={field.name} style={{paddingRight}}>
                                            <NumberField
                                                inline={this.props.inline}
                                                field={{...field,gridConfigs}}
                                                label={_label}
                                                variant={variant}
                                                required={field.required}
                                                value={data[field.name]||0}
                                                row={data}
                                                margin={margin}
                                                step={gridConfigs.step}
                                                fullWidth
                                                readOnly={readOnly}
                                                //disabled={readOnly}
                                                format={gridConfigs.format}
                                                mediaQueryMatches ={this.props.mediaQueryMatches}
                                                InputLabelProps={(gridConfigs||{}).InputLabelProps}
                                                inputProps={(gridConfigs||{}).inputProps}
                                                helperText={(field.help_text||'').toString()}
                                                InputProps={{
                                                    style:gridConfigs.style,
                                                    readOnly,
                                                    ...((gridConfigs||{}).InputProps||{}),
                                                    ...InputProps_mediaQueryMatches
                                                   // disabled:readOnly,
                                                   // disableUnderline: true,
                            
                                                }}
                                                onChange={(event)=>this.handleValueChanged(field,{[field.name]:Number(event.target.value)})}
                                            />
                                        </Grid>
                                    )
                                }else{
                                    return(
                                        <Grid  {..._props} size={gridSize}  key={field.name} style={{paddingRight}}>
                                            <TextField
                                                inline={this.props.inline}
                                                field={{...field,gridConfigs}}
                                                style={gridConfigs.style}
                                                margin={margin}
                                                variant={variant}
                                                required={field.required && !this.props.noValidate?true:false}
                                                fullWidth
                                                type={(gridConfigs.inputType || field.type||"").toLowerCase()}
                                                label={_label}
                                                autoComplete="new-password"
                                                value={data[field.name]||""}
                                                row={data}
                                                disabled={gridConfigs.disabled}
                                                InputLabelProps={{ shrink: true,...(gridConfigs||{}).InputLabelProps}}
                                                helperText={(field.help_text||'').toString()}
                                                autoFocus={gridConfigs.autoFocus}
                                                mediaQueryMatches ={this.props.mediaQueryMatches}
                                                readOnly={readOnly}
                                                inputProps={(gridConfigs||{}).inputProps}
                                                InputProps={{
                                                    readOnly: readOnly,
                                                    maxLength: field.maxlength,
                                                    autoFocus:gridConfigs.autoFocus,
                                                    ...((gridConfigs||{}).InputProps||{}),
                                                    ...InputProps_mediaQueryMatches
                                                }}
                                                onChange={(event)=>this.handleValueChanged(field,{[field.name]:field.uppercase?(event.target.value||"").toUpperCase():event.target.value})}
                                            />
                                        </Grid>
                                    )
                                }}
                            }
                        }}
                    })}
                </Grid>
            </div>
            
        )
    }
    isHidden(field,master,data={},type="not_input"){
        if(!field[type]) return false;
        let expression = field[type].toString();
        if(expression.toLowerCase()==="true") return true;
        if(expression.toLowerCase()==="false") return false;
        try{
          expression = (expression.indexOf("return ")<0?"return ":"") + expression;
          const func= new Function("master","detail","context","mediaQueryMatches", expression);
          let rs =  func(master|| data,data,this.context,this.props.mediaQueryMatches);
          return rs;
        }catch(e){
          console.error(e,".Check expression:",expression);
          return false;
        }
    }
    prepareFields(data,fields){
        let {group,style} = this.props;
        if(!fields) fields = this.props.fields;
        this.fields = cloneDeep(fields);

        this.fields.forEach(field=>{
            field.visible = (!this.isHidden(field,this.props.master,data,"not_input") && field.type!=="Link");
        })

        this.fields = this.fields.sort((a,b)=>(a.stt||0)-(b.stt||0));
        this.group = group;
        this.style = style;
        const fields_of_group = fields.filter(f=>f.group===group);
        this.tabs = [...new Set(fields_of_group.filter(f=>f.tab).sort((a,b)=>(a.stt||0)-(b.stt||0)).map(f=>f.tab))];
        this._fields_not_tab = fields.filter(f=>!f.tab && f.group===group);
    }
    render(){
        let {tabs,group,fields,style} = this;
        if(!fields || fields.filter(f=>f.visible).length===0) return null;
        let {data} = this.state;
        let _style_fields = {backgroundColor:this.props.backgroundColorFields,...style};
        let tabName;
        if(tabs.length>0){
            tabName = tabs[this.state.currentTab];
            _style_fields.padding =0;
        }
        tabs = tabs.filter(tab_name=>{
            return fields.filter(f=>f.tab === tab_name && f.visible).length>0
        })
        let _style_fields_in_tab = {..._style_fields};
        if(_style_fields_in_tab.maxHeight){
            _style_fields_in_tab.maxHeight = "60vh";
        }

        const orientation = this.props.orientation;
        const backgroundColorBar =  this.props.backgroundColorBar || (orientation=="vertical" && !!tabName && tabs.length>1?"#F3F3F3":undefined);
        const backgroundColorFields = this.props.backgroundColorFields ||  (orientation=="vertical"?"white":undefined);
        return(
            <>
                <div class="flex-group-component" style={{display:"flex",flexDirection:"column",height:"100%",overflowY: this.props.inline?"hidden":undefined,overflowX: this.props.inline?"auto":"hidden"}}>
                    {this._fields_not_tab.length>0 && this.renderFields("",group,data,fields,_style_fields,undefined,this.props.justify)}
                    <div class="flex-group-component-container" style={{flex:1,display:"flex",overflow:"auto",flexDirection:(orientation=="vertical"?"row":"column"),backgroundColor:backgroundColorBar}}>
                        {!!tabName && tabs.length>1  && 
                            <div class="flex-group-component-tabs">
                                <AppBar position="static" color="default" elevation={group || orientation=="vertical"?0:1}>
                                    <Tabs value={this.state.currentTab}
                                        variant="scrollable"
                                        orientation={orientation}
                                        scrollButtons="auto"
                                        onChange={(event, newValue)=>this.setState({currentTab:newValue})}>
                                        {tabs.map((tab,index)=>{
                                            return(
                                                <Tab key={index.toString()} label={this.context.apis.getLabel(tab || "Thông tin khác")} />
                                            )
                                        })}
                                    </Tabs>
                                </AppBar>
                            </div>
                        }
                        <div class="flex-group-component-fields" style={{flex:1,overflow:"auto",backgroundColor:backgroundColorFields}}>
                            {!!tabName && this.renderFields(tabName,group,data,fields,_style_fields_in_tab,undefined,this.props.justify)}
                        </div>
                    </div>
                </div>
                <ObjectPicker ref={ref=>this.refObjectPicker= ref} formSize="md" readOnly={true} hideHeader={true}/>
            </>
        )
    }
}

GroupTabs.contextType = AuthContext;
GroupTabs.propTypes={
    name:PropTypes.string,
    idApp:PropTypes.string,
    inline:PropTypes.bool,//inline form, Tất cả các field sẽ nằm trên một dòng
    code:PropTypes.string,
    group:PropTypes.string,
    fields:PropTypes.arrayOf(PropTypes.object).isRequired,
    handleValueChanged:PropTypes.func.isRequired,
    data:PropTypes.object,
    noValidate:PropTypes.bool,
    history:PropTypes.any,
    parent:PropTypes.any,
    mainForm:PropTypes.any,
    style:PropTypes.any,
    justify:PropTypes.any,
    defaultGridConfigs:PropTypes.any,
    readOnly:PropTypes.bool,
    master:PropTypes.object,
    dataPickers:PropTypes.any,
    mediaQueryMatches:PropTypes.bool,
    showFieldName:PropTypes.bool,
    orientation:PropTypes.oneOf(["vertical","horizontal"]),
    backgroundColorBar:PropTypes.string,
    backgroundColorFields:PropTypes.string,
}
export default GroupTabs;